import { Icon, Loader } from '@kenect-ut/kenect-ui-kit'
import classNames from 'classnames'
import union from 'lodash/union'
import PropTypes from 'prop-types'
import { Field } from 'react-final-form'

function BrandCheckbox({
  input,
  id,
  brandId,
  brandIds,
  allBrandsIsChecked,
  form,
  onValueChange,
}) {
  const handleChange = (event) => {
    const preemptiveValue = union(brandIds, [brandId])
    if (preemptiveValue.length === 1) {
      // If the preemptiveValue length is one, we know they are trying to remove the last selected brand. This is not aloud.
      return
    } else if (allBrandsIsChecked) {
      form.mutators.clearAllBrands()
      input.onChange([brandId])
    } else {
      input.onChange(event)
    }

    onValueChange()
  }

  return <input id={id} className="hide" {...input} onChange={handleChange} />
}

BrandCheckbox.propTypes = {
  input: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  brandId: PropTypes.number.isRequired,
  brandIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  allBrandsIsChecked: PropTypes.bool.isRequired,
  form: PropTypes.object.isRequired,
  onValueChange: PropTypes.func.isRequired,
}

function BrandDropdownForm({
  userBrands,
  loading,
  formValues,
  form,
  onValueChange,
}) {
  const brandIds = formValues?.brandIds || []
  const allBrandsIsChecked = userBrands.length === brandIds?.length
  const allBrandsIconClassName = classNames(
    'brandSelectIcon',
    allBrandsIsChecked && 'isVisible',
  )

  const handleAllBrandsClick = () => {
    form.mutators.setAllBrands()
    onValueChange()
  }

  return (
    <form className="brandSelectWrapper">
      <div className="brandSelectOptions">
        <button
          type="button"
          className="brandSelectOption"
          onClick={handleAllBrandsClick}
        >
          <Icon name="check" className={allBrandsIconClassName} />
          <span>All Brands</span>
        </button>

        <div className="break" />
        {userBrands.map((brand) => {
          const id = `brand_${brand.id}`
          const isChecked = brandIds.includes(brand.id)
          const iconClassName = classNames(
            'brandSelectIcon',
            isChecked && !allBrandsIsChecked && 'isVisible',
          )
          return (
            <label key={id} htmlFor={id} className="brandSelectOption">
              <Icon name="check" className={iconClassName} />
              <span>{brand.name}</span>
              <Field
                name="brandIds"
                type="checkbox"
                value={brand.id}
                component={BrandCheckbox}
                id={id}
                brandId={brand.id}
                brandIds={brandIds}
                allBrandsIsChecked={allBrandsIsChecked}
                form={form}
                onValueChange={onValueChange}
              />
            </label>
          )
        })}
      </div>

      {loading && <Loader color="var(--kenect-blue)" size={12} />}
    </form>
  )
}

BrandDropdownForm.propTypes = {
  userBrands: PropTypes.array,
  loading: PropTypes.bool,
  formValues: PropTypes.shape({
    brandIds: PropTypes.arrayOf(PropTypes.number),
    allBrands: PropTypes.bool,
  }),
  form: PropTypes.object,
  onValueChange: PropTypes.func.isRequired,
}

export default BrandDropdownForm
